import { Injectable } from '@angular/core';
import { MessageService } from '@services/helpers/message-service/message.service';
import { MailsDataProvider } from '@services/email/mails.data.service';
import { EmailServiceProvider } from '@services/email/email-service/email.service';
import { StringModifierServiceProvider } from '@services/helpers/string-modifier-service/stringModifier.service';
import { EmailSendData, Mail } from '@models/models';

interface MailData {
	chosenEmail: any;
	chosenQuestionnaire?: any;
}

interface MessageParametres {
	messageData: EmailSendData;
	jobId: number;
	mailData: MailData;
	questionnaireId?: number;
}

interface DataToSend {
	emailTo: Array<string>;
	ccEmails?: Array<string>;
	secondaryToEmails?: Array<string>;
	emailText: string;
	emailSubject: string;
	questionnaireTemplateId: number | null;
	jobId: number;
	templateId: number;
}

@Injectable()
export class QuestionnairesServiceProvider {
	constructor(
		private messageService: MessageService,
		private mailsDataService: MailsDataProvider,
		private emailService: EmailServiceProvider,
		private stringModifierService: StringModifierServiceProvider
	) {}

	setDefaultEmail(emails: Array<any>) {
		if (emails !== undefined && emails !== null && emails.length) {
			return (
				emails.find(
					item => item.emailTemplateType === 'QUESTIONNAIRE_EMAIL_TEMPLATE'
				) || {}
			);
		}
		return null;
	}

	successSendEmail() {
		this.messageService.showToaster('s_9', 'jobView');
		this.mailsDataService.emitMailUpdateEvent(true);
	}

	errorSendMessage(result): void {
		const { data } = result;
		const { errorMessage, errorTitle } = data;
		this.messageService.showErrorFromBackend(errorTitle, errorMessage);
	}

	gatherDataToSendQuest(data: MessageParametres, isNew: boolean) {
		const { messageData, jobId, mailData, questionnaireId } = data;
		const { attachmentsData } = messageData;
		const { storedFiles, uploadedFiles } = this.emailService.prepareAttachments(
			attachmentsData
		);

		let sendMessageData;
		if (isNew) {
			sendMessageData = this.prepareNewQuestMailToSend(
				messageData,
				jobId,
				mailData
			);
		} else {
			sendMessageData = this.prepareExistingQuestMailToSend(
				messageData,
				jobId,
				mailData,
				questionnaireId
			);
		}

		return {
			sendMessageData,
			storedFiles,
			uploadedFiles
		};
	}

	prepareQuestToSave(questionnaire) {
		if (questionnaire && questionnaire.name) {
			questionnaire.name = this.stringModifierService.cutSelectedText(
				questionnaire.name
			);
		}
		return questionnaire;
	}

	private prepareNewQuestMailToSend(messageData, jobId, mailData): DataToSend {
		const result: DataToSend = {
			emailTo: messageData.emailTo,
			emailText: messageData.emailText || '',
			emailSubject: messageData.emailSubject,
			questionnaireTemplateId: mailData.chosenQuestionnaire
				? mailData.chosenQuestionnaire.id
				: null,
			jobId,
			templateId: mailData.chosenEmail.id
		};

		if (messageData.secondaryToEmails && messageData.secondaryToEmails.length) {
			result.secondaryToEmails = messageData.secondaryToEmails;
		}

		if (messageData.ccEmails && messageData.ccEmails.length) {
			result.ccEmails = messageData.ccEmails;
		}

		return result;
	}

	private prepareExistingQuestMailToSend(
		messageData,
		jobId,
		mailData,
		questionnaireId
	): DataToSend {
		const result: DataToSend = {
			emailTo: messageData.emailTo,
			emailText: messageData.emailText || '',
			emailSubject: messageData.emailSubject,
			questionnaireTemplateId: questionnaireId,
			jobId,
			templateId: mailData.chosenEmail.id
		};

		if (messageData.secondaryToEmails && messageData.secondaryToEmails.length) {
			result.secondaryToEmails = messageData.secondaryToEmails;
		}

		if (messageData.ccEmails && messageData.ccEmails.length) {
			result.ccEmails = messageData.ccEmails;
		}

		return result;
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./shared/services/questionnarie/questionnaires-service/questionnaires.service.ts